import BaseModel from "../default/base-model";

export class IntegrationRoutines extends BaseModel {
    id: number;
    rfc: string;
    descricao: string;
    is_active: boolean;
    ultima_execucao: string;
    status: IntegrationRoutineStatus;
    last_error_message: string;
    tipo: number;

    constructor() {
        super();
        this.id = 0;
        this.rfc = '';
        this.descricao = '';
        this.is_active = true;
        this.ultima_execucao = '';
        this.status = IntegrationRoutineStatus.PENDING;
        this.last_error_message = '';
        this.tipo = 0;
    }
}

export enum IntegrationRoutineStatus {
    PENDING = 'PENDENTE',
    SUCCESS = 'SUCESSO',
    FAILED = 'ERRO',
}

export const mapStatusString ={
    [IntegrationRoutineStatus.PENDING]: 'PENDENTE',
    [IntegrationRoutineStatus.SUCCESS]: 'SUCESSO',
    [IntegrationRoutineStatus.FAILED]: 'ERRO',
}

export const mapStatusColor = {
    [IntegrationRoutineStatus.PENDING]: 'info',
    [IntegrationRoutineStatus.SUCCESS]: 'success',
    [IntegrationRoutineStatus.FAILED]: 'error',
}

export class ExecuteRFCManual {
    plant: string;
    sloc: string;
    material_type: string;
    material: string;
    application_bom: string;
    sales_org: string;

    begin_date: string;
    end_date: string;
    purchase_order_types: string[];
    tipo: number;

    id_cliente: number;
    client_nf: string;
    part_number: string;
    date: string;

    constructor() {
        this.plant = '451N'
        this.sloc = 'W001'
        this.material_type = 'ZUNB',
        this.material = 'FTB',
        this.application_bom = 'PP01',
        this.sales_org = 'BR45';

        this.begin_date = '';
        this.end_date = '';
        this.purchase_order_types = [];
        this.tipo = 0;

        this.id_cliente = 0;
        this.client_nf = '';
        this.part_number = '';
        this.date = '';
    }
}

export enum TypeSapImportLog {
    EXECUCAO_PO_LOGISTICS_COSTS = 5,
    EXECUCAO_MANUAL_CUSTOMER_INVOICES = 6,
    EXECUCAO_MANUAL_SPARE_PARTS = 7,
    EXECUCAO_MANUAL_BOM_STOCK = 8,
    EXECUCAO_MANUAL_MOV_SPARE_PARTS = 9,
    EXECUCAO_MANUAL_NRE_FORECAST = 10,
    EXECUCAO_MANUAL_NRE_ORDER = 11,
}


export class ExecuteRFCManualConfig {
    plant: string;
    sloc: string;
    material_type: string;
    material: string;
    application_bom: string;
    sales_org: string;

    begin_date: boolean;
    end_date: boolean;
    purchase_order_types: boolean;
    id_cliente: boolean;
    client_nf: boolean;
    part_number: boolean;
    date: boolean;

    tipo: boolean;

    constructor() {
        this.plant = '451N'
        this.sloc = 'W001'
        this.material_type = 'ZUNB',
        this.material = 'FTB',
        this.application_bom = 'PP01',
        this.sales_org = 'BR45';

        this.begin_date = false;
        this.end_date = false;
        this.purchase_order_types = false;
        this.id_cliente = false;
        this.client_nf = false;
        this.part_number = false;
        this.date = false;

        this.tipo = true;
    }
}

export const mapExecuteRFCManualConfig = {
    [TypeSapImportLog.EXECUCAO_PO_LOGISTICS_COSTS]: Object.assign(new ExecuteRFCManualConfig(), {  material: null, application_bom: null, material_type: null, sloc: null, begin_date: true, end_date: true, purchase_order_types: true }),//ok

    [TypeSapImportLog.EXECUCAO_MANUAL_CUSTOMER_INVOICES]: Object.assign(new ExecuteRFCManualConfig(), { begin_date: true, end_date: true, id_cliente: true, sales_org: true, material: null, application_bom: null, material_type: null, sloc: null, plant: null }),//ok

    [TypeSapImportLog.EXECUCAO_MANUAL_SPARE_PARTS]: Object.assign(new ExecuteRFCManualConfig(), {material: null, application_bom: null}), //ok

    [TypeSapImportLog.EXECUCAO_MANUAL_BOM_STOCK]: Object.assign(new ExecuteRFCManualConfig(), { date: true, material_type: null, sloc: null, sales_org: null }), //ok

    [TypeSapImportLog.EXECUCAO_MANUAL_MOV_SPARE_PARTS]: Object.assign(new ExecuteRFCManualConfig(), {material: null, application_bom: null, material_type: null, begin_date: true, end_date: true, sales_org: null }), //ok

    [TypeSapImportLog.EXECUCAO_MANUAL_NRE_FORECAST]: Object.assign(new ExecuteRFCManualConfig(), { material: null, application_bom: null, material_type: null, sloc: null, date: true, sales_org: null }),//ok

    [TypeSapImportLog.EXECUCAO_MANUAL_NRE_ORDER]: Object.assign(new ExecuteRFCManualConfig(), { material: null, application_bom: null, material_type: null, sloc: null, begin_date: true, end_date: true, sales_org: null }),//ok
}

export class ExecutionLogRfc extends BaseModel{
    id: number;
    description: string;
    import_date: string;
    problems_occurred: string;
    total_imported: number;
    process_time: string;
    type: number;
    user: string;
    request_parameters: string;

    constructor() {
        super();
        this.id = 0;
        this.description = '';
        this.import_date = '';
        this.problems_occurred = '';
        this.total_imported = 0;
        this.type = 0;
        this.user = '';
        this.request_parameters = '';
        this.process_time = '';
    }
}

